import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, CalendarCheck, Home } from "lucide-react";
import { SEO } from "@/components/site/SEO";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-ivory" data-testid="not-found-page">
      <SEO
        title="Page Not Found | Legacy Life & Retirement"
        description="The page you were looking for could not be found. Return to Legacy Life & Retirement, explore resources, or book a strategy call."
        robots="noindex, follow"
        noCanonical
      />
      <Header />
      <main>
        <section className="relative bg-ivory pt-[120px] md:pt-[150px] pb-20 md:pb-28 overflow-hidden">
          <div className="pointer-events-none absolute inset-0 grid-lines opacity-50" />
          <div className="container-lr relative max-w-3xl text-center">
            <div className="mx-auto inline-flex items-center gap-3 rounded-full border border-gold/40 bg-white px-5 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-bronze">
              <span className="h-px w-8 bg-gold" />
              404
              <span className="h-px w-8 bg-gold" />
            </div>
            <h1 className="mt-7 font-serif font-semibold tracking-display text-legacy text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              We Could Not Find That Page.
            </h1>
            <p className="mt-6 text-slate text-base md:text-lg leading-relaxed">
              The page may have moved, the address may be incorrect, or the resource may no longer be available at this link.
            </p>
            <p className="mt-4 text-slate/90 text-sm md:text-base leading-relaxed">
              You can return home, continue learning through the resource library, or book a strategy call when you are ready for a conversation.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/" className="btn-base btn-primary" data-testid="not-found-home">
                <Home size={18} />
                Return Home
              </Link>
              <Link to="/resources" className="btn-base btn-outline-dark" data-testid="not-found-resources">
                <BookOpen size={18} />
                View Resources
              </Link>
              <Link to="/strategy-call" className="btn-base btn-gold" data-testid="not-found-strategy-call">
                <CalendarCheck size={18} />
                Book a Strategy Call
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
